import { createFileRoute } from '@tanstack/react-router';
import { Billing } from '../../organisms/Billing';

type Search =
  | {
      stripeState: 'failed' | 'success' | undefined;
      invoice: string | undefined;
    }
  | undefined;

export const Route = createFileRoute('/_authenticated/billing')({
  validateSearch: (search: Search | undefined) =>
    search
      ? {
          stripeState: search.stripeState,
          invoice: search.invoice,
        }
      : {},
  component: RouteComponent,
});

function RouteComponent() {
  return <Billing />;
}
